import React from 'react';

import { Icon } from 'semantic-ui-react';

import { SortableHandle } from 'react-sortable-hoc';

const DragHandle = SortableHandle(() => (
  <Icon name="ellipsis vertical" className="drag-handle" title="Drag to reorder" />
));

export default DragHandle;
